import RequireContext = __WebpackModuleApi.RequireContext;

function requireAll(r: RequireContext) {
  r.keys().forEach(r);
}

function getBaseURL() {
  return `${window.location.protocol}//${window.location.hostname}${(window.location.port ? `:${window.location.port}` : '')}`;
}

function domReady(callback: () => void) {
  if (document.readyState === 'complete' || document.readyState !== 'loading') {
    callback();
  }
  else {
    document.addEventListener('DOMContentLoaded', callback);
  }
}

export async function fetchSVG(filename: string) {
  const baseUrl = getBaseURL();
  let url: string | null = filename || null;

  if (!url) {
    return Promise.reject(new Error('Invalid URL'));
  }

  url = (`${baseUrl}/${url}`).replace(/([^:]\/)\/+/g, '$1');

  const resp = await fetch(url, {});
  if (resp.status < 200 || resp.status >= 300) {
    return Promise.reject(new Error(`Invalid HTTP Code - HTTP code: ${resp.status} (${resp.statusText})`));
  }

  const responseText = await resp.text();
  if (!responseText || responseText.slice(0, 4) !== '<svg') {
    return Promise.reject(new Error('Invalid SVG Response '));
  }

  const div = document.createElement('div');
  div.innerHTML = responseText;
  div.setAttribute('id', 'svg-icon-sprite');
  domReady(() => {
    document.body.insertAdjacentElement('beforeend', div);
  });

  return Promise.resolve();
}

export function loadIcons() {
  requireAll(require.context('@project/assets/icons', true, /\.svg$/));
}
